var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AntInput from "antd/es/input";
/**
 * @param {any} [props] Props for this component.
 * @return {JSX.Element} JSX Element
 * @type {React.FunctionComponent<any>}
 */
const SearchInput = forwardRef((_a, ref) => {
    var { className, placeholder, size } = _a, props = __rest(_a, ["className", "placeholder", "size"]);
    const classes = classNames("gerudo-input", "gerudo-input-search", className, {
        lg: size === "large",
        sm: size === "small",
    });
    return React.createElement(AntInput.Search, Object.assign({ className: classes, placeholder: placeholder, ref: ref, size: size }, props));
});
SearchInput.displayName = "SearchInput";
SearchInput.defaultProps = {
    onClick: () => { },
    className: "",
    placeholder: "",
    size: "large",
    onChange: () => { },
    onBlur: () => { },
    addonBefore: null,
    addonAfter: null,
    defaultValue: "",
    maxLength: null,
    enterButton: false,
    loading: false,
    onSearch: () => { },
    allowClear: false,
};
SearchInput.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.oneOf(["large", "small"]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    addonBefore: PropTypes.node,
    addonAfter: PropTypes.node,
    defaultValue: PropTypes.string,
    maxLength: PropTypes.number,
    enterButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    loading: PropTypes.bool,
    onSearch: PropTypes.func,
    allowClear: PropTypes.bool,
    value: PropTypes.string,
    name: PropTypes.string,
};
export default SearchInput;
//# sourceMappingURL=index.js.map